export default "/images/framework/GrandBarCht.a6999235.svg?a6999235";